export const summationBasic = `const config = {
  formulas: [
    {
      id: "summation-basic",
      latex: "E = \\\\sum_{x \\\\in X} x P(x)"
    },
  ],
  variables: {
    E: {
      default: 0,
      name: "Expected Value",
      latexDisplay: "name",
      labelDisplay: "value",
    },
    x: {
      name: "Member of X",
      latexDisplay: "name",
      labelDisplay: "value",
    },
    X: {
      default: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      latexDisplay: "name",
      labelDisplay: "value",
    },
    "P(x)": {
      key: "x",
      default: [0.05, 0.08, 0.12, 0.15, 0.20, 0.18, 0.12, 0.06, 0.03, 0.01],
      name: "Probability of x",
      latexDisplay: "name",
      labelDisplay: "value",
    }
  },
  stepping: true,
  semantics: function({ vars, step }) {
    var xValues = vars.X;
    var pxValues = vars["P(x)"];
    var expectedValue = vars.E;
    for (var i = 0; i < xValues.length; i++) {
      var xi = xValues[i];
      var probability = pxValues[i];
      if (i === 0) {
        step({ description: "Get a value x from X", labels: { "x": xi, "X": xValues } });
        step({ description: "Get a value P(x) from P(x)", labels: { "P(x)": probability } });
      }
      var currExpected = Math.round(xi * probability * 100) / 100;
      if (i === 0) {
        step({ labels: { "x": xi, "P(x)": probability, "x P(x)": "This evaluates to: " + currExpected } });
      }
      expectedValue = Math.round((expectedValue + currExpected) * 100) / 100;
      switch (i) {
        case 0:
          step({ description: "add up term into E", labels: { "E": expectedValue } });
          break;
        case 1:
          step({ description: "add next term...", labels: { "E": expectedValue } });
          break;
        case xValues.length - 1:
          step({ description: "finish accumulating weighted sum", labels: { "E": expectedValue } });
          break;
      }
    }
    vars.E = expectedValue;
  },
  fontSize: 1.5
};`;
